import { Criticality_00, Criticality_10, Criticality_20 } from './types.js';
export const CriticalityLabelMap = {
    [Criticality_00]: 'Non Urgent',
    [Criticality_10]: 'Urgent',
    [Criticality_20]: 'Critical',
};
//# sourceMappingURL=consts.js.map